import React from "react";
import { Link } from "react-router-dom";
import { Badge, IconButton, Tooltip } from "@material-ui/core";
import InboxOutlinedIcon from "@material-ui/icons/InboxOutlined";
import { useInbox } from "../../context/Inbox";

export default function InboxButton() {
  const { unreadCount } = useInbox();
  return (
    <Tooltip title={`Meu inbox${unreadCount ? ` · ${unreadCount} não ${unreadCount === 1 ? "lido" : "lidos"}` : ""}`}>
      <IconButton component={Link} to="/inbox" aria-label={`Meu inbox, ${unreadCount} ${unreadCount === 1 ? "registro não lido" : "registros não lidos"}`} color="inherit">
        <Badge badgeContent={unreadCount} color="primary" max={99}><InboxOutlinedIcon /></Badge>
      </IconButton>
    </Tooltip>
  );
}
